// import React from "react";
// import Markdown from "react-markdown";
// import { useLocation, Navigate } from "react-router-dom";
// import rehypeRaw from "rehype-raw";
// import ReactPlayer from "react-player";
// import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
// import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
// import CoverImage from "../assets/sxm/cover.jpg";
// import CodeImage2 from "../assets/sxm/code-2.png";
// import FlowchartImage from "../assets/sxm/flowchart.png";
// // import { ChevronLeft } from "lucide-react";
// import TableOfContents from "../components/TableOfContents";

// const images = {
// 	CodeImage2,
// 	FlowchartImage,
// };

// // Code Editor Component
// const CodeEditor = ({ codeString }) => {
// 	return (
// 		<div className="my-12 mx-auto max-w-full">
// 			<div className="bg-[#1e1e1e] rounded-xl overflow-hidden shadow-2xl border border-gray-800">
// 				{/* Code Content */}
// 				<div className="relative">
// 					<SyntaxHighlighter
// 						language="javascript"
// 						style={vscDarkPlus}
// 						customStyle={{
// 							margin: 0,
// 							padding: "1.5rem",
// 							background: "#1e1e1e",
// 							fontSize: "14px",
// 							lineHeight: "1.5",
// 							fontFamily:
// 								'"Fira Code", "Monaco", "Menlo", "Ubuntu Mono", monospace',
// 						}}
// 						showLineNumbers={true}
// 						lineNumberStyle={{
// 							color: "#6e7681",
// 							paddingRight: "1rem",
// 							userSelect: "none",
// 							minWidth: "3rem",
// 						}}
// 						wrapLines={true}
// 						wrapLongLines={true}
// 					>
// 						{codeString}
// 					</SyntaxHighlighter>

// 					{/* Copy Button */}
// 					<button className="absolute top-4 right-4 p-2 bg-gray-800 hover:bg-gray-700 rounded-md transition-colors duration-200 opacity-0 hover:opacity-100 group-hover:opacity-100">
// 						<svg
// 							className="w-4 h-4 text-gray-300"
// 							fill="none"
// 							stroke="currentColor"
// 							viewBox="0 0 24 24"
// 						>
// 							<path
// 								strokeLinecap="round"
// 								strokeLinejoin="round"
// 								strokeWidth={2}
// 								d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
// 							/>
// 						</svg>
// 					</button>
// 				</div>
// 			</div>
// 		</div>
// 	);
// };

// const SAS = () => {
// 	const location = useLocation();
// 	const isAuthenticated =
// 		(location.state && location.state.isAuthenticated) ||
// 		(typeof window !== "undefined" &&
// 			localStorage.getItem("protectedAccess") === "granted");

// 	if (!isAuthenticated) {
// 		return <Navigate to="/" />;
// 	}

// 	return (
// 		<div
// 			className="flex flex-col w-full min-h-screen items-center p-4 lg:p-20 gap-y-8 lg:gap-y-20 bg-[#C4DEFD]"
// 			style={{
// 				paddingLeft: "max(1.25rem, calc(var(--toc-right-edge, 0px) + 1rem))",
// 			}}
// 		>
// 			<TableOfContents
// 				content={content}
// 				pageName="SiriusXM"
// 				accentColor="#0600ED"
// 			/>
// 			<div className="flex flex-col lg:flex-row header w-full max-w-[1000px] bg-[#0600ED] text-white p-4 lg:p-20 rounded-3xl bg-gradient-to-b from-white/20 via-white/50 to-white/80 shadow-[0_0_0_1px_rgba(0,0,0,0.08),0_-2px_1px_0_rgba(0,0,0,0.08)_inset,0_2px_1px_0_rgba(255,255,255,0.5)_inset,0_2px_5px_-1px_rgba(0,0,0,0.05),0_1px_3px_-1px_rgba(0,0,0,0.3)]">
// 				<div className="flex flex-col w-full lg:min-w-[400px] lg:max-w-[400px]">
// 					<h1 className="text-6xl lg:text-[110px] font-medium mb-4 tracking-[-0.04em] lg:mt-0 mt-12">
// 						SiriusXM
// 					</h1>
// 					<div className="details grid grid-cols-2 w-full lg:w-[385px] gap-y-2 gap-x-4 text-sm lg:text-base">
// 						<p className="font-semibold text-right">Project Duration</p>
// 						<p>January - August 2025</p>
// 						<p className="font-semibold text-right">Location</p>
// 						<p>New York, NY</p>
// 						<p className="font-semibold text-right">Role</p>
// 						<p className="leading-tight">Design Technologist Intern</p>
// 						<p className="font-semibold text-right">Tools Used</p>
// 						<div className="flex flex-col leading-tight mt-[2px]">
// 							<p>Framer</p>
// 							<p>TypeScript</p>
// 							<p>React</p>
// 							<p>OpenAI API</p>
// 						</div>
// 					</div>
// 				</div>
// 				<div className="flex w-full items-center justify-center mt-8 lg:mt-0">
// 					<img
// 						src={CoverImage}
// 						alt="hero"
// 						className="object-contain w-full max-w-[300px] lg:max-w-[500px] rounded-2xl lg:ml-20"
// 					/>
// 				</div>
// 			</div>
// 			<div className="body w-full pt-8 lg:pt-10 max-w-[1000px] p-4 lg:p-20 bg-[#C4DEFD] rounded-3xl shadow-[inset_0_0_10px_0_rgba(0,0,0,0.1)]">
// 				<Markdown
// 					rehypePlugins={[rehypeRaw]}
// 					components={{
// 						h1: ({ node, children, ...props }) => {
// 							const text = typeof children === "string" ? children : "";
// 							const id = text
// 								.toLowerCase()
// 								.replace(/[^a-z0-9]+/g, "-")
// 								.replace(/(^-|-$)/g, "");
// 							return (
// 								<h1
// 									id={id}
// 									className="text-4xl font-bold my-8 text-center"
// 									{...props}
// 								>
// 									{children}
// 								</h1>
// 							);
// 						},
// 						h2: ({ node, children, ...props }) => {
// 							const text = typeof children === "string" ? children : "";
// 							const id = text
// 								.toLowerCase()
// 								.replace(/[^a-z0-9]+/g, "-")
// 								.replace(/(^-|-$)/g, "");
// 							return (
// 								<h2 id={id} className="text-3xl font-bold mb-6 mt-4" {...props}>
// 									{children}
// 								</h2>
// 							);
// 						},
// 						h3: ({ node, children, ...props }) => {
// 							const text = typeof children === "string" ? children : "";
// 							const id = text
// 								.toLowerCase()
// 								.replace(/[^a-z0-9]+/g, "-")
// 								.replace(/(^-|-$)/g, "");
// 							return (
// 								<h3 id={id} className="text-2xl font-semibold mb-2" {...props}>
// 									{children}
// 								</h3>
// 							);
// 						},
// 						h4: ({ node, children, ...props }) => (
// 							<h4
// 								className="text-2xl font-semibold mb-2 leading-tight"
// 								{...props}
// 							>
// 								{children}
// 							</h4>
// 						),
// 						h5: ({ node, children, ...props }) => (
// 							<h5 className="text-2xl font-medium mb-2" {...props}>
// 								{children}
// 							</h5>
// 						),
// 						h6: ({ node, children, ...props }) => (
// 							<h6
// 								className="text-sm italic text-center mt-[-32px] mb-8"
// 								{...props}
// 							>
// 								{children}
// 							</h6>
// 						),
// 						p: ({ node, ...props }) => (
// 							<p className="mb-4 leading-tight text-neutral-800" {...props} />
// 						),
// 						img: ({ node, ...props }) => {
// 							const imageSrc = images[props.src] || props.src;
// 							if (imageSrc.endsWith(".mp4")) {
// 								return (
// 									<ReactPlayer
// 										url={imageSrc}
// 										controls
// 										className="my-12 rounded-2xl w-full"
// 									/>
// 								);
// 							}
// 							return (
// 								<img
// 									src={imageSrc}
// 									alt={props.alt}
// 									className="h-full object-contain my-12 max-h-[500px] rounded-2xl mx-auto"
// 								/>
// 							);
// 						},
// 						code: ({ node, ...props }) => (
// 							<code className="bg-gray-100 p-1 rounded-md" {...props} />
// 						),
// 					}}
// 				>
// 					{content1}
// 				</Markdown>

// 				<div className="aspect-video w-full mb-12">
// 					<ReactPlayer
// 						url="https://youtu.be/MTICNc1-hLM"
// 						controls
// 						className="my-8 lg:my-12 rounded-2xl mx-auto"
// 						width="auto"
// 						height="100%"
// 					/>
// 				</div>
// 				<Markdown
// 					rehypePlugins={[rehypeRaw]}
// 					components={{
// 						h1: ({ node, children, ...props }) => {
// 							const text = typeof children === "string" ? children : "";
// 							const id = text
// 								.toLowerCase()
// 								.replace(/[^a-z0-9]+/g, "-")
// 								.replace(/(^-|-$)/g, "");
// 							return (
// 								<h1
// 									id={id}
// 									className="text-4xl font-bold my-8 text-center"
// 									{...props}
// 								>
// 									{children}
// 								</h1>
// 							);
// 						},
// 						h2: ({ node, children, ...props }) => {
// 							const text = typeof children === "string" ? children : "";
// 							const id = text
// 								.toLowerCase()
// 								.replace(/[^a-z0-9]+/g, "-")
// 								.replace(/(^-|-$)/g, "");
// 							return (
// 								<h2 id={id} className="text-3xl font-bold mb-6 mt-4" {...props}>
// 									{children}
// 								</h2>
// 							);
// 						},
// 						h3: ({ node, children, ...props }) => {
// 							const text = typeof children === "string" ? children : "";
// 							const id = text
// 								.toLowerCase()
// 								.replace(/[^a-z0-9]+/g, "-")
// 								.replace(/(^-|-$)/g, "");
// 							return (
// 								<h3 id={id} className="text-2xl font-semibold mb-2" {...props}>
// 									{children}
// 								</h3>
// 							);
// 						},
// 						h4: ({ node, children, ...props }) => (
// 							<h4
// 								className="text-2xl font-semibold mb-2 leading-tight"
// 								{...props}
// 							>
// 								{children}
// 							</h4>
// 						),
// 						h5: ({ node, children, ...props }) => (
// 							<h5 className="text-2xl font-medium mb-2" {...props}>
// 								{children}
// 							</h5>
// 						),
// 						h6: ({ node, children, ...props }) => (
// 							<h6
// 								className="text-sm italic text-center mt-[-32px] mb-8"
// 								{...props}
// 							>
// 								{children}
// 							</h6>
// 						),
// 						p: ({ node, ...props }) => (
// 							<p className="mb-4 leading-tight text-neutral-800" {...props} />
// 						),
// 						img: ({ node, ...props }) => {
// 							const imageSrc = images[props.src] || props.src;
// 							if (imageSrc.endsWith(".mp4")) {
// 								return (
// 									<ReactPlayer
// 										url={imageSrc}
// 										controls
// 										className="my-12 rounded-2xl w-full"
// 									/>
// 								);
// 							}
// 							return (
// 								<img
// 									src={imageSrc}
// 									alt={props.alt}
// 									className="h-full object-contain my-12 max-h-[500px] rounded-2xl mx-auto"
// 								/>
// 							);
// 						},
// 						code: ({ node, ...props }) => (
// 							<code className="bg-gray-100 p-1 rounded-md" {...props} />
// 						),
// 					}}
// 				>
// 					{content2}
// 				</Markdown>

// 				<CodeEditor codeString={codeString2} />

// 				<div className="aspect-video w-full">
// 					<ReactPlayer
// 						url="https://youtu.be/_aOxZJ0zDoU"
// 						controls
// 						className="my-8 lg:my-12 rounded-2xl mx-auto"
// 						width="auto"
// 						height="100%"
// 					/>
// 				</div>
// 				<Markdown
// 					rehypePlugins={[rehypeRaw]}
// 					components={{
// 						h1: ({ node, children, ...props }) => {
// 							const text = typeof children === "string" ? children : "";
// 							const id = text
// 								.toLowerCase()
// 								.replace(/[^a-z0-9]+/g, "-")
// 								.replace(/(^-|-$)/g, "");
// 							return (
// 								<h1
// 									id={id}
// 									className="text-4xl font-bold my-8 text-center"
// 									{...props}
// 								>
// 									{children}
// 								</h1>
// 							);
// 						},
// 						h2: ({ node, children, ...props }) => {
// 							const text = typeof children === "string" ? children : "";
// 							const id = text
// 								.toLowerCase()
// 								.replace(/[^a-z0-9]+/g, "-")
// 								.replace(/(^-|-$)/g, "");
// 							return (
// 								<h2 id={id} className="text-3xl font-bold mb-6 mt-4" {...props}>
// 									{children}
// 								</h2>
// 							);
// 						},
// 						h3: ({ node, children, ...props }) => {
// 							const text = typeof children === "string" ? children : "";
// 							const id = text
// 								.toLowerCase()
// 								.replace(/[^a-z0-9]+/g, "-")
// 								.replace(/(^-|-$)/g, "");
// 							return (
// 								<h3 id={id} className="text-2xl font-semibold mb-2" {...props}>
// 									{children}
// 								</h3>
// 							);
// 						},
// 						h4: ({ node, children, ...props }) => (
// 							<h4
// 								className="text-2xl font-semibold mb-2 leading-tight"
// 								{...props}
// 							>
// 								{children}
// 							</h4>
// 						),
// 						h5: ({ node, children, ...props }) => (
// 							<h5 className="text-2xl font-medium mb-2" {...props}>
// 								{children}
// 							</h5>
// 						),
// 						h6: ({ node, children, ...props }) => (
// 							<h6
// 								className="text-sm italic text-center mt-[-32px] mb-8"
// 								{...props}
// 							>
// 								{children}
// 							</h6>
// 						),
// 						p: ({ node, ...props }) => (
// 							<p className="mb-4 leading-tight text-neutral-800" {...props} />
// 						),
// 						img: ({ node, ...props }) => {
// 							const imageSrc = images[props.src] || props.src;
// 							if (imageSrc.endsWith(".mp4")) {
// 								return (
// 									<ReactPlayer
// 										url={imageSrc}
// 										controls
// 										className="my-12 rounded-2xl mx-auto"
// 									/>
// 								);
// 							}
// 							return (
// 								<img
// 									src={imageSrc}
// 									alt={props.alt}
// 									className="h-full object-contain my-12 max-h-[500px] rounded-2xl mx-auto"
// 								/>
// 							);
// 						},
// 					}}
// 				>
// 					{content3}
// 				</Markdown>
// 				<p className="text-sm text-center mt-12 italic">
// 					Note: This information may not be shared publicly due to company
// 					policy. Thank you for your understanding!
// 				</p>
// 			</div>
// 		</div>
// 	);
// };

// export default SAS;

import { useEffect, useState } from "react";
import { ArrowLeftIcon } from "lucide-react";
import TableOfContents from "../components/TableOfContents";
import MarkdownRenderer from "../components/MarkdownRenderer";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import ReactPlayer from "react-player";
import CoverImage from "../assets/sxm/cover.jpg";
import CodeImage2 from "../assets/sxm/code-2.png";
import FlowchartImage from "../assets/sxm/flowchart.png";
import VoiceAgentsDemo from "../assets/sxm/voice-agents-demo.mp4";
import GenUIDemo from "../assets/sxm/gen-ui-demo.mov";

const images = {
	CoverImage,
	CodeImage2,
	FlowchartImage,
	VoiceAgentsDemo,
	GenUIDemo,
};

const SiriusXM = () => {
	const [markdownContent1, setMarkdownContent1] = useState("");
	const [markdownContent2, setMarkdownContent2] = useState("");
	const [markdownContent3, setMarkdownContent3] = useState("");
	const navigate = useNavigate();

	const location = useLocation();
	const isAuthenticated =
		(location.state && location.state.isAuthenticated) ||
		(typeof window !== "undefined" &&
			localStorage.getItem("protectedAccess") === "granted");

	useEffect(() => {
		window.scrollTo(0, 0);

		// Only load markdown content if authenticated
		if (isAuthenticated) {
			// Load all three markdown files
			Promise.all([
				fetch("/content/siriusxm.md").then((response) => response.text()),
				fetch("/content/siriusxm2.md").then((response) => response.text()),
				fetch("/content/siriusxm3.md").then((response) => response.text()),
			])
				.then(([text1, text2, text3]) => {
					setMarkdownContent1(text1);
					setMarkdownContent2(text2);
					setMarkdownContent3(text3);
				})
				.catch((error) => {
					console.error("Error loading markdown:", error);
					// Fallback content
					setMarkdownContent1(
						"Content loading failed. Please refresh the page."
					);
				});
		}
	}, [isAuthenticated]);

	if (!isAuthenticated) {
		return <Navigate to="/" />;
	}

	return (
		<div className="relative grid w-full min-h-screen bg-[#F5F1E5] grid-cols-1 lg:grid-cols-[200px_1fr_200px] grid-rows-[30px_1fr_30px]">
			{/* Mobile fixed top bar with Back button */}
			<div className="fixed inset-x-0 top-0 z-40 lg:hidden bg-[#F5F1E5] h-14">
				<div
					className="absolute bottom-0 left-0 right-0 h-[2px]"
					style={{
						background: `linear-gradient(to bottom, #FFFFFF 0%, #FFFFFF 50%, #BFA99F 50%, #BFA99F 100%)`,
					}}
				/>
				<div className="h-full flex items-center px-4">
					<button
						className="flex items-center font-semibold space-x-2 text-white text-sm px-2 py-1 rounded-full bg-[#0600ED] shadow"
						onClick={() => navigate("/")}
					>
						<ArrowLeftIcon className="w-3 h-3 transition-transform duration-200" />
						<span>Back</span>
					</button>
				</div>
			</div>
			{/* Top container (was top border line) */}
			<div className="relative hidden lg:block col-span-3 row-start-1 h-[30px] pointer-events-none z-20">
				<div
					className="absolute bottom-0 left-0 right-0 h-[2px] z-20"
					style={{
						background: `linear-gradient(to bottom, #FFFFFF 0%, #FFFFFF 50%, #BFA99F 50%, #BFA99F 100%)`,
					}}
				/>
			</div>

			{/* Vertical lines overlay spanning both rows */}
			<div className="pointer-events-none absolute inset-0 z-10 hidden lg:block">
				<div
					className="absolute top-0 bottom-0 left-[200px] w-[2px]"
					style={{
						background: `linear-gradient(to right, #BFA99F 0%, #BFA99F 50%, #FFFFFF 50%, #FFFFFF 100%)`,
					}}
				/>
				<div
					className="absolute top-0 bottom-0 right-[200px] w-[2px]"
					style={{
						background: `linear-gradient(to left, #BFA99F 0%, #BFA99F 50%, #FFFFFF 50%, #FFFFFF 100%)`,
					}}
				/>
			</div>

			{/* Left container (holds TOC and inner right-edge border) */}
			<div className="relative row-start-2 col-start-1 hidden lg:flex flex-col p-2">
				<div className="fixed hidden lg:flex items-start justify-start z-20">
					<TableOfContents
						content={[markdownContent1, markdownContent2, markdownContent3]}
						pageName="SiriusXM"
						accentColor="#0600ED"
						homeOnly={false}
						darkMode={false}
						inline
					/>
				</div>
			</div>

			{/* Right container (empty, with inner left-edge border) */}
			<div className="relative hidden lg:block row-start-2 col-start-3"></div>

			{/* Center content */}
			<div className="row-start-2 col-start-1 lg:col-start-2 flex flex-col w-full min-w-0 items-center gap-y-8 px-5 sm:px-8 lg:px-14 pt-16 lg:pt-0 bg-white overflow-x-hidden shadow-[0_0_12px_rgba(0,0,0,0.15)]">
				{/* Header Container */}
				<div className="flex flex-col w-full max-w-[1000px] h-fit justify-center items-center mt-0 lg:mt-[30px] gap-2 bg-[#0600ED] text-white p-4 rounded-2xl border-[#B7B3B0] bg-gradient-to-b from-white/20 via-white/50 to-white/80 shadow-[0_0_0_1px_rgba(0,0,0,0.08),0_-2px_1px_0_rgba(0,0,0,0.08)_inset,0_2px_1px_0_rgba(255,255,255,0.5)_inset,0_2px_5px_-1px_rgba(0,0,0,0.05),0_1px_3px_-1px_rgba(0,0,0,0.3)]">
					<div className="flex w-full justify-center items-center">
						<div className="flex w-fit mx-auto px-3 py-1 border border-neutral-300 text-sm text-neutral-300 rounded-full">
							Design Technologist Internship
						</div>
					</div>
					<p className="text-center text-sm text-neutral-300">
						January - August 2025
					</p>
					<h1 className="text-center text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.04em]">
						SiriusXM
					</h1>
					<img
						src={CoverImage}
						alt="hero"
						className="object-contain max-h-[300px] rounded-2xl my-2"
					/>
					<div className="flex w-full max-w-[1000px] justify-center font-mono tracking-tighter text-sm text-neutral-500 gap-3 sm:gap-6 flex-wrap overflow-hidden">
						<p>Framer</p>
						<p>TypeScript</p>
						<p>React</p>
						<p>OpenAI API</p>
					</div>
				</div>
				<div className="body w-full max-w-[1000px] min-w-0 p-4 rounded-3xl overflow-hidden">
					{/* First markdown section */}
					<MarkdownRenderer
						markdown={markdownContent1}
						images={images}
						className="w-full max-w-full min-w-0 overflow-hidden"
					/>

					{/* First YouTube video */}
					<div className="aspect-video w-full mt-8 lg:mt-12">
						<ReactPlayer
							url="https://youtu.be/MTICNc1-hLM"
							controls
							className="rounded-2xl mx-auto"
							width="100%"
							height="100%"
						/>
					</div>

					{/* Second markdown section */}
					<MarkdownRenderer
						markdown={markdownContent2}
						images={images}
						className="w-full max-w-full min-w-0 overflow-hidden"
					/>

					{/* Second YouTube video */}
					<div className="aspect-video w-full mt-8 lg:mt-12">
						<ReactPlayer
							url="https://youtu.be/_aOxZJ0zDoU"
							controls
							className="rounded-2xl mx-auto"
							width="100%"
							height="100%"
						/>
					</div>

					{/* Third markdown section */}
					<MarkdownRenderer
						markdown={markdownContent3}
						images={images}
						className="w-full max-w-full min-w-0 overflow-hidden"
					/>
				</div>
				<p className="text-sm text-center mb-12 italic">
					Note: This content may not be shared publicly due to company policy.
					Thank you for your understanding!
				</p>
				{/* Close center content wrapper */}
			</div>

			{/* Bottom container (mirror of top border line) */}
			<div className="relative col-span-1 lg:col-span-3 row-start-3 h-[30px] pointer-events-none z-20">
				<div
					className="absolute top-0 left-0 right-0 h-[2px] z-20"
					style={{
						background: `linear-gradient(to bottom, #FFFFFF 0%, #FFFFFF 50%, #BFA99F 50%, #BFA99F 100%)`,
					}}
				/>
			</div>
		</div>
	);
};

export default SiriusXM;
